/**
 * Convert media not supported error into download link
 * @param mediaElement audio or video element
 * @param notSupportedTextError string of not supported text
 * @param downloadLinkText string of download file
 */
export default (mediaElement: HTMLAudioElement | HTMLVideoElement, notSupportedErrorText: string, downloadLinkText: string, unitTest?: boolean) => {
    if (unitTest || (mediaElement.error !== null && mediaElement.error.code === 4)) {
        mediaElement.style.display = "none";
        mediaElement.insertAdjacentHTML(
            "afterend",
            `<div class="MediaError">${notSupportedErrorText} (<a href="${mediaElement.getAttribute("src")}">${downloadLinkText}</a>)</div>`
        );
    }
};
